/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Agent_Triggers_Event_Backlog_BlockedInputs */



/**
* | output |
* | --- |
* | "Paused: {count} runs unfinished" |
*
* @param {Agent_Triggers_Event_Backlog_BlockedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_triggers_event_backlog_blocked = /** @type {((inputs: Agent_Triggers_Event_Backlog_BlockedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Triggers_Event_Backlog_BlockedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Angehalten: ${i?.count} Läufe nicht abgeschlossen`)
	return /** @type {LocalizedString} */ (`Paused: ${i?.count} runs unfinished`)
});